// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2X3GZ","calendarButtons":"ClockData_calendarButtons__3JcRF"};